import React from 'react';
import { InfoWindow } from '@react-google-maps/api';

const CompetitorInfoWindow = ({ competitor, position, onClose }) => {
  if (!competitor) return null;

  const rating = competitor.rating;
  const ratingColor =
    rating >= 4.0 ? '#22c55e' :
    rating >= 3.0 ? '#eab308' :
    rating >= 2.0 ? '#f97316' : '#ef4444';

  const statusColor =
    competitor.business_status === 'OPERATIONAL' ? '#22c55e' :
    competitor.business_status === 'CLOSED_TEMPORARILY' ? '#f97316' : '#ef4444';

  const icon = competitor.type === 'gas_station' ? '⛽' : '🏪';

  return (
    <InfoWindow position={position} onCloseClick={onClose}>
      <div style={{ minWidth: 230, fontFamily: 'system-ui, sans-serif', color: '#1f2937' }}>
        <h4 style={{ margin: '0 0 8px', fontSize: 14, fontWeight: 700, borderBottom: '2px solid #f97316', paddingBottom: 6 }}>
          {icon} {competitor.name || 'Unknown'}
        </h4>
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          {rating != null && (
            <div>
              <b>Rating:</b>{' '}
              <span style={{ color: ratingColor, fontWeight: 700 }}>{rating} ⭐</span>
              {competitor.user_ratings_total != null && (
                <span style={{ color: '#6b7280' }}> ({competitor.user_ratings_total.toLocaleString()} reviews)</span>
              )}
            </div>
          )}
          <div><b>Distance:</b> {competitor.distance_miles != null ? `${competitor.distance_miles} mi` : 'N/A'}</div>
          <div>
            <b>Status:</b>{' '}
            <span style={{ color: statusColor, fontWeight: 600 }}>
              {(competitor.business_status || 'UNKNOWN').replace(/_/g, ' ')}
            </span>
          </div>
          {competitor.address && (
            <div style={{ marginTop: 4, fontSize: 12, color: '#6b7280' }}>
              📍 {competitor.address}
            </div>
          )}
          {competitor.amenities && competitor.amenities.length > 0 && (
            <div style={{ marginTop: 6 }}>
              <b>Amenities:</b>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
                {competitor.amenities.map((amenity, i) => (
                  <span key={i} style={{
                    background: '#f3f4f6',
                    padding: '2px 8px',
                    borderRadius: 12,
                    fontSize: 11,
                    color: '#374151'
                  }}>
                    {amenity}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </InfoWindow>
  );
};

export default CompetitorInfoWindow;
